export class UploadDataCounterpart {
    ContentId: number;
    VoiceTalentId: number;
}